import ProductGrid from "./dinissan/products/ProductGrid.svelte";
import Catalog from "./dinissan/products/Catalog.svelte";
import ProfileVehicles from "./dinissan/profile/ProfileVehicles.svelte";
import ValidateForm from "./dinissan/validate/ValidateForm.svelte";
import Menu from "./dinissan/layout/Menu.svelte";
import SelectCity from "./dinissan/checkout/SelectCity.svelte";
import Cart from "./dinissan/checkout/Cart.svelte";
import Shipping from "./dinissan/checkout/Shipping.svelte";
import AddressList from "./dinissan/address/AddressList.svelte";
import Billing from "./dinissan/checkout/Billing.svelte";
import Confirm from "./dinissan/checkout/Confirm.svelte";
import ValidatePage from "./dinissan/validate/ValidatePage.svelte";
import ValidateHeader from "./dinissan/validate/ValidateHeader.svelte";
import Part from "./dinissan/cart/Part.svelte";
import Accessory from "./dinissan/cart/Accessory.svelte";
import Service from "./dinissan/cart/Service.svelte";
import SearchDinissan from "./dinissan/search/SearchDinissan.svelte";
import Revision from "./dinissan/products/Revision.svelte";
import RevisionPage from "./dinissan/maintenance/RevisionPage.svelte";
import MaintenancePage from "./dinissan/MaintenancePage.svelte";
import MaintenanceCatalog from "./dinissan/maintenance/MaintenanceCatalog.svelte";
import MaintenancePrice from "./dinissan/cart/MaintenancePrice.svelte";
import PrepaidMaintenanceCatalog from "./dinissan/maintenance/PrepaidMaintenanceCatalog.svelte";
import Favorite from "./dinissan/Favorite.svelte";
import Related from "./dinissan/Related.svelte";
import Sign from "./dinissan/Sign.svelte";
import WishList from "./dinissan/WishList.svelte";
import MultipleCatalog from "./dinissan/products/MultipleCatalog.svelte";
import CatalogPage from "./dinissan/products/CatalogPage.svelte";
import { getCart } from "./models/cart";
import FormPlaca from "./dinissan/validate/FormPlaca.svelte";
import ConfirmVehicle from "./dinissan/ConfirmVehicle.svelte";
import { getQueryParams, pushState, setFlag } from "./utils";
import CartConfirmVehicle from "./dinissan/CartConfirmVehicle.svelte";
import { ManagerVehicles } from "./models/manager-vehicles";
export default {
    ProductGrid,
    Catalog,
    CatalogPage,
    MultipleCatalog,
    ProfileVehicles,
    ValidatePage,
    ValidateForm,
    Menu,
    SelectCity,
    Cart,
    Shipping,
    AddressList,
    Billing,
    Confirm,
    ValidateHeader,
    Part,
    Accessory,
    Service,
    SearchDinissan,
    Revision,
    RevisionPage,
    MaintenancePage,
    MaintenanceCatalog,
    MaintenancePrice,
    PrepaidMaintenanceCatalog,
    Favorite,
    Related,
    Sign,
    WishList,
    FormPlaca,
    ConfirmVehicle,
    CartConfirmVehicle,
    getCart,
    setFlag,
    getQueryParams,
    pushState,
    ManagerVehicles
};
